export default __webpack_public_path__ + "static/test_2_2_ru-0944e33e3cffec464ecab09da39010e1.png";